<template lang="pug">
form.columns.align-center.my-2(@submit.prevent="onFilter")
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_numero_eq')")
    small {{ filters.ordem_servico_numero_eq }}
    int.form-input.input-sm(v-model="q.ordem_servico_numero_eq" placeholder="Número")
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_ano_eq')")
    small {{ filters.ordem_servico_ano_eq }}
    year.form-input.input-sm(v-model="q.ordem_servico_ano_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('situacao_eq')")
    small {{ filters.situacao_eq }}
    select-analise-situacao.form-select.select-sm(v-model="q.situacao_eq")
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_cadastro_id_eq')")
    small {{ filters.ordem_servico_cadastro_id_eq }}
    cadastro-picker(v-model="q.ordem_servico_cadastro_id_eq" sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_created_at_gteq')")
    small {{ filters.ordem_servico_created_at_gteq }}
    datepicker(v-model='q.ordem_servico_created_at_gteq' input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_created_at_lteq')")
    small {{ filters.ordem_servico_created_at_lteq }}
    datepicker(v-model='q.ordem_servico_created_at_lteq' input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_concluido_em_gteq')")
    small {{ filters.ordem_servico_concluido_em_gteq }}
    datepicker(v-model='q.ordem_servico_concluido_em_gteq' input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_concluido_em_lteq')")
    small {{ filters.ordem_servico_concluido_em_lteq }}
    datepicker(v-model='q.ordem_servico_concluido_em_lteq' full-day input-class='form-input input-sm')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_contribuinte_cpf_cnpj_eq')")
    small {{ filters.ordem_servico_contribuinte_cpf_cnpj_eq }}
    input-cpf-cnpj.form-input.input-sm(v-model='q.ordem_servico_contribuinte_cpf_cnpj_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_cadastro_zona_eq')")
    small {{ filters.ordem_servico_cadastro_zona_eq }}
    input.form-input.input-sm(v-model='q.ordem_servico_cadastro_zona_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_cadastro_quadra_eq')")
    small {{ filters.ordem_servico_cadastro_quadra_eq }}
    input.form-input.input-sm(v-model='q.ordem_servico_cadastro_quadra_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_cadastro_lote_eq')")
    small {{ filters.ordem_servico_cadastro_lote_eq }}
    input.form-input.input-sm(v-model='q.ordem_servico_cadastro_lote_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_protocolo_tipo_eq')")
    small {{ filters.ordem_servico_protocolo_tipo_eq }}
    select-protocolo-tipo.select-sm(v-model='q.ordem_servico_protocolo_tipo_eq' sm)
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_protocolo_numero_eq')")
    small {{ filters.ordem_servico_protocolo_numero_eq }}
    input.form-input.input-sm(v-model='q.ordem_servico_protocolo_numero_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_protocolo_ano_eq')")
    small {{ filters.ordem_servico_protocolo_ano_eq }}
    input.form-input.input-sm(v-model='q.ordem_servico_protocolo_ano_eq')
  .pb-1.column.col-auto(v-if="isEnabledFilter('ordem_servico_assunto_id_eq')")
    small {{ filters.ordem_servico_assunto_id_eq }}
    assunto-picker(v-model="q.ordem_servico_assunto_id_eq" sm)
  .pb-1.column.col-auto.tooltip.tooltip-bottom(v-if="isEnabledFilter('ordem_servico_assunto_compartilhado_eq')" data-tooltip='Com outros departamentos')
    small {{ filters.ordem_servico_assunto_compartilhado_eq }}
    select.form-select.select-sm(v-model="q.ordem_servico_assunto_compartilhado_eq" sm)
      option(:value='undefined') Todos
      option(:value='true') Sim
      option(:value='false') Não
  .pb-1.column.col-auto
    small Ordenar por
    order-by(:fields="orderByFields", :query="q", sm)
  .column.col-auto
    .label-padding-top.d-flex
      enabled-filters(
        localStorageKey="osm_servicos_enabled_filters",
        :defaultEnabledFilters="defaultEnabledFilters",
        :enabledFilters="enabledFilters",
        :filters="filters",
        :query="q",
        :setEnabledFilters="setEnabledFilters"
      )
      a.btn.btn-link.btn-sm.no-print.tooltip.tooltip-bottom(
        data-tooltip="Imprimir",
        onclick="window.print()"
      )
        i.fa.fa-lg.fa-print
      button.btn.btn-sm.btn-link.tooltip.tooltip-bottom(
        data-tooltip="Filtrar",
        :disabled="$v.q.$invalid"
      )
        i.fa.fa-search.fa-lg
      slot(name="additionalButtons")
</template>

<script>
import filterMixin, { defaultStoreImports } from "@/mixins/filter"

export default {
  data() {
    return {
      filters: {
        ordem_servico_numero_eq: `OS-m ${this.$options.filters.tModel(
          "ordem_servico.numero",
        )}`,
        ordem_servico_ano_eq: `OS-m ${this.$options.filters.tModel(
          "ordem_servico.ano",
        )}`,
        situacao_eq: this.$options.filters.tModel(
          "ordem_servico_analise.situacao",
        ),
        ordem_servico_cadastro_id_eq: this.$options.filters.tModel("cadastro"),
        ordem_servico_created_at_gteq: "Data início OS-m",
        ordem_servico_created_at_lteq: "Data fim OS-m",
        ordem_servico_cadastro_id_null: "Apenas avulsas",
        ordem_servico_concluido_em_gteq: "Data conclusão início OS-m",
        ordem_servico_concluido_em_lteq: "Data conclusão fim OS-m",
        ordem_servico_contribuinte_cpf_cnpj_eq: "CPF/CNPJ do contribuinte",
        ordem_servico_cadastro_zona_eq: this.$options.filters.tModel(
          "cadastro.zona",
        ),
        ordem_servico_cadastro_quadra_eq: this.$options.filters.tModel(
          "cadastro.quadra",
        ),
        ordem_servico_cadastro_lote_eq: this.$options.filters.tModel(
          "cadastro.lote",
        ),
        ordem_servico_protocolo_tipo_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_tipo",
        ),
        ordem_servico_protocolo_numero_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_numero",
        ),
        ordem_servico_protocolo_ano_eq: this.$options.filters.tModel(
          "ordem_servico.protocolo_ano",
        ),
        ordem_servico_assunto_id_eq: this.$options.filters.tModel(
          "ordem_servico.assunto",
        ),
        ordem_servico_assunto_compartilhado_eq: "Assunto compartilhado",
      },
      defaultEnabledFilters: [
        "ordem_servico_numero_eq",
        "ordem_servico_ano_eq",
        "ordem_servico_analise.situacao",
        "situacao_eq",
      ],
      orderByFields: {
        ordem_servico_numero: this.$options.filters.tModel(
          "ordem_servico.numero",
        ),
        ordem_servico_ano: this.$options.filters.tModel("ordem_servico.ano"),
      },
    }
  },
  methods: {
    onToggleCadastroIdNull() {
      if (!this.q.ordem_servico_cadastro_id_null)
        this.$delete(this.q, "ordem_servico_cadastro_id_null")
    },
  },
  validations: {
    q: {},
  },
  vuex: { "analises/minhasAnalises": defaultStoreImports },
  mixins: [filterMixin],
}
</script>
